import { LeafMark, scrollToId } from "@/lib/site";
import { Lock, ShieldCheck, FileText } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#12261A] text-[#FAF7F2]/70 pt-14 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10 pb-10 border-b border-[#FAF7F2]/10">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5 mb-4">
              <LeafMark className="w-9 h-9" />
              <span className="font-display text-xl font-bold text-[#FAF7F2]">
                TeaMethod<span className="text-[#D4A359]">.</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed">
              The Sustainable Tea &amp; Weight Loss Method — a science-informed guide to healthier
              habits, tea rituals and lasting results.
            </p>
          </div>

          <nav className="flex flex-col gap-2.5 text-sm" data-testid="footer-links">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#D4A359] mb-1">Explore</p>
            {[
              ["Benefits", "benefits"],
              ["What's Inside", "inside"],
              ["Reviews", "reviews"],
              ["FAQ", "faq"],
              ["Get the Guide", "pricing"],
            ].map(([label, id]) => (
              <button
                key={id}
                onClick={() => scrollToId(id)}
                className="text-left hover:text-[#D4A359] transition-colors duration-300 w-fit"
                data-testid={`footer-link-${id}`}
              >
                {label}
              </button>
            ))}
          </nav>

          <div className="flex flex-col gap-3 text-xs" data-testid="footer-trust">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#D4A359] mb-1">Trust</p>
            <span className="flex items-center gap-2"><Lock className="w-4 h-4 text-[#D4A359]" /> Secure 256-bit SSL checkout</span>
            <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-[#D4A359]" /> 30-day money-back guarantee</span>
            <span className="flex items-center gap-2"><FileText className="w-4 h-4 text-[#D4A359]" /> Instant PDF download</span>
          </div>
        </div>

        <p className="mt-8 text-[11px] leading-relaxed text-[#FAF7F2]/45 max-w-4xl" data-testid="footer-disclaimer">
          Important: This ebook is for educational purposes only and is not intended to diagnose, treat,
          cure or prevent any disease. Results vary from person to person. Consult a healthcare
          professional before using herbs, especially if you are pregnant, breastfeeding or taking medication.
        </p>
        <p className="mt-4 text-[11px] text-[#FAF7F2]/40">
          © {new Date().getFullYear()} TeaMethod — The Sustainable Tea &amp; Weight Loss Method. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
